document.addEventListener( 'DOMContentLoaded', () => {
	const passwordProtectedPage = document.getElementsByClassName( 'post-password-required' );

	if ( 0 < passwordProtectedPage.length ) {
		/**
		 * Clear Password Protected Form - START
		 */

		const clearableInputElements = document.getElementsByClassName( 'clearable' );
		const resetFormElement = document.getElementById( 'post-password-form__reset' );

		if ( 0 < clearableInputElements.length ) {
			for ( const elem of clearableInputElements ) {
				elem.addEventListener( 'input', () => {
					resetFormElement.classList.remove( 'd-none' );
				} );
			}
		}

		if ( resetFormElement ) {
			resetFormElement.addEventListener( 'click', () => {
				resetFormElement.classList.add( 'd-none' );
			} );
		}

		/**
		 * Clear Password Protected Form - END
		 */
	}
} );
